import { useIsomorphicLayoutEffect } from "hooks/useIsomorphicLayoutEffect";
import React, { useContext, useState, useCallback } from "react";
import { CalculatorContext } from "./CalculatorContext";
import s from "./styles/CalculatorCustomStyles.module.css";

const INCREMENT = 1;

function CalculatorInput({ max, paramType, label, sublabel }) {
  const { setCalculatorParams, calculatorParams } =
    useContext(CalculatorContext);
  const [inputValue, setInputValue] = useState<number>(
    calculatorParams.deposit
  );
  const [isMax, setIsMax] = useState(false);

  useIsomorphicLayoutEffect(() => {
    setInputValue(calculatorParams.deposit.toFixed(0));
  }, [calculatorParams.deposit]);
  useIsomorphicLayoutEffect(() => {
    setIsMax(false);
  }, [calculatorParams.type]);

  // Implement a debounce function
  const debounceInput = useCallback(
    (value) => {
      if (value < 0) return;
      if (value === 0) {
        setCalculatorParams((prevParams) => ({
          ...prevParams,
          [paramType]: 0,
        }));
        return;
      }
      // Runde die Eingabe auf das Inkrement
      const roundedValue = Math.round(value / INCREMENT) * INCREMENT;

      setCalculatorParams((prevParams) => ({
        ...prevParams,
        [paramType]: roundedValue,
      }));
    },
    [paramType, setCalculatorParams]
  );

  // Function to handle input changes with debounce

  const subtractPercentToGetMaxAmount = (inputValue) => {
    if (typeof inputValue === "number" && !isNaN(inputValue)) {
      const percentage = calculatorParams.type === "leasing" ? 0.7 : 0.6;
      const result = inputValue - inputValue * percentage;
      const roundedResult = parseFloat(result.toFixed(0));
      return roundedResult;
    } else {
      throw new Error("Die Eingabe muss eine gültige Zahl sein.");
    }
  };
  let maxDeposit = subtractPercentToGetMaxAmount(max);
  const handleInputChange = (e) => {
    const newValue = e.target.value <= maxDeposit ? e.target.value : maxDeposit;
    setIsMax(newValue >= maxDeposit);
    setInputValue(newValue);
    debounceInput(newValue);
  };
  return (
    <div className="flex flex-wrap relative">
      <label htmlFor="delayedInput">
        <p className="text-3xl  text-blue-dark font-semibold">{label}</p>
      </label>
      <input
        className={`${s.CalcInput} font-semibold lg:text-left text-center border-2 border-blue-dark  disabled:opacity-50 disabled:border-alert disabled:cursor-not-allowed w-full px-6 py-5 mt-4 border-none bg-gray-100 text-base text-gray-600`}
        type="number"
        id="delayedInput"
        value={inputValue >= 0 ? inputValue : 0}
        onChange={handleInputChange}
      />
      <span className="absolute font-bold text-gray-600 right-5 top-1/2 mt-4 transform -translate-y-1/2 ">
        €
      </span>
      <p className={`text-sm mt-2 ${isMax ? "text-alert" : "text-white"}`}>
        {sublabel}max. {maxDeposit}€&#041;
      </p>{" "}
    </div>
  );
}

export default CalculatorInput;
